import React from 'react';
import './Table.scss';

const TableWrapper = ({ children }) => (<div className='table-wrapper-c696c390-4d32-4bb7-be44-99e6bb6b45ec'>{children}</div>)

export { TableWrapper };
